/* eslint-disable */
import changeCase from 'change-object-case';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert, Glyphicon } from 'react-bootstrap';
import { ss, url, authJsonHeader, mapDispatch } from '../../utils/util';
import Highlighter from "react-highlight-words";

import OzFormComponent from './OzFormComponent';
import './IntegrationForm.css';

import {
} from '../../actions';


class IntegrationForm extends OzFormComponent {

  static fields = [
    'bookingSystem',
    'accessToken',
    'code',
    'companyId',
    'locationId',
  ];

  renderBody() {
    let locationOptions = this.props.locations.map(l => [l.id, l.address]);

    let needsLocation = ['bookeo', 'checkfront'].includes(this.state.bookingSystem);

    return (
      <div className="IntegrationForm">
        <div><b>Company:</b> {this.props.company.name}</div>
        <div><b>Booking system:</b> {this.state.bookingSystem}</div>
        {this.state.accessToken && <div><b>Access token:</b> {this.state.accessToken}</div>}
        {this.state.code && <div><b>Code:</b> {this.state.code}</div>}
        <hr/>
        {needsLocation && this.renderFormGroup('Which location is this integration for?', 'select', 'locationId', locationOptions)}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(IntegrationForm);



/** WEBPACK FOOTER **
 ** ./src/components/partials/IntegrationForm.js
 **/